/**
 * Centralized Font Family Constants
 */
export const FONTS = {
  // Main headings and UI elements
  heading: "'Montserrat', sans-serif",

  // Script / Accent font for brand or highlights
  accent: "'Allura', cursive",

  // Default body font (if specified separately)
  body: "'Montserrat', sans-serif"
};
